export const testimonials = [
  {
    name: "Emily Richardson",
    handle: "@emily_finds",
    avatarColor: "oklch(0.68 0.14 30)",
    text: "The Hipobuy Spreadsheet completely changed how I approach online shopping. Having everything organized in one place with clear category breakdowns saves me hours every week. I have recommended it to all my friends who love discovering new products efficiently.",
  },
  {
    name: "Marcus Chen",
    handle: "@marcus_style",
    avatarColor: "oklch(0.72 0.15 58)",
    text: "I was skeptical about spreadsheet shopping at first, but the Hipobuy Spreadsheet resource proved incredibly valuable. The comparison features alone make it worth checking out. I have discovered so many quality items I would have missed otherwise.",
  },
  {
    name: "Sophia Laurent",
    handle: "@sophia_wardrobe",
    avatarColor: "oklch(0.66 0.10 142)",
    text: "As someone who loves fashion but hates endless scrolling, the Hipobuy Spreadsheet approach is a game-changer. The organized categories and detailed information help me make confident purchasing decisions without the usual overwhelm.",
  },
  {
    name: "James O'Brien",
    handle: "@james_picks",
    avatarColor: "oklch(0.68 0.14 30 / 0.7)",
    text: "Finding reliable product information used to be a headache until I discovered Hipobuy Spreadsheet resources. The safety tips and verification guides gave me the confidence to explore new categories I had never considered before.",
  },
  {
    name: "Ava Nilsson",
    handle: "@ava_discovers",
    avatarColor: "oklch(0.72 0.15 58 / 0.7)",
    text: "The Hipobuy Spreadsheet platform has become my go-to resource for smart shopping. The regularly updated listings mean I am always seeing fresh products, and the organization makes it easy to find exactly what I need.",
  },
  {
    name: "Daniel Park",
    handle: "@daniel_essentials",
    avatarColor: "oklch(0.66 0.10 142 / 0.7)",
    text: "I appreciate how the Hipobuy Spreadsheet community values transparency and detailed information. Every product listing I have explored through their resources has been well-documented with accurate details that match what arrives.",
  },
];